module.exports = __webpack_public_path__ + "img/call.3232e65e.svg";